import type { DataShape } from '../../services/fields';

export const PREFIX: keyof Pick<DataShape, 'p2tg'> = 'p2tg';
